import { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { toast } from './Toaster.jsx';

const CHECK_EVERY_MS = 60 * 60 * 1000;

export default function UpdatePrompt() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      if (!registration) return;
      setInterval(() => {
        if (navigator.onLine) registration.update().catch(() => {});
      }, CHECK_EVERY_MS);
    },
  });

  useEffect(() => {
    if (!needRefresh || !navigator.serviceWorker?.controller) return;
    toast.info('A new version of Recall is ready.', {
      duration: 0,
      action: { label: 'Update', onClick: () => updateServiceWorker(true) },
    });
  }, [needRefresh, updateServiceWorker]);

  return null;
}
